import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const Container = styled.div`
    width: 212px;
    padding: 6px 0;
`;

export const SegmentContainer = styled.div<{
    index: number;
}>`
    margin-top: ${(props) => (props.index !== 0 ? 16 : 0)}px;
`;

export const SegmentTitle = styled.p`
    ${setFontVariant("captionTitle", colorsPalettes.carbon[250])};
`;

export const Listing = styled.p`
    margin: 8px 0 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
`;
